<template>
	<div class="contact-qr">
		<div class="qr-image">
			<img v-if="image" :src="image" :alt="$t('contact.qrCode')" width="320" height="320">
			<span v-if="failed" role="alert">{{ $t('contact.qrError') }}</span>
		</div>
		<div class="qr-text">
			<strong>{{ $t('contact.scanToContact') }}</strong>
			<small>{{ url.replace(/^https?:\/\//i, '') }}</small>
		</div>
	</div>
</template>

<script setup>
import QRCode from 'qrcode';
import { ref, watch } from 'vue';

const props = defineProps({ url: { type: String, required: true } });
const image = ref('');
const failed = ref(false);

watch(() => props.url, async (url, previous, onCleanup) => {
	let cancelled = false;
	onCleanup(() => { cancelled = true; });
	image.value = '';
	failed.value = false;
	try {
		const result = await QRCode.toString(url, { type: 'svg', margin: 4, errorCorrectionLevel: 'M' });
		if (!cancelled) image.value = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(result);
	} catch {
		if (!cancelled) failed.value = true;
	}
}, { immediate: true });
</script>
